import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetTagsReset, EGetTagsActionType } from './types';

export const getTagsReset: () => TGetTagsReset = actionGenerator<EGetTagsActionType.Reset>(EGetTagsActionType.Reset);
